<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
    <circle cx="20" cy="20" r="20" style="fill: #019ddf" />
    <g>
      <circle cx="20" cy="11.5" r="3" style="fill: none;stroke: #fff;stroke-linecap: round;stroke-linejoin: round" />
      <path d="M24.5,16.5h-9c0,2.08,1,5,3,5.7v4.3h3V22.2C23.5,21.5,24.5,18.58,24.5,16.5Z"
        style="fill: none;stroke: #fff;stroke-linecap: round;stroke-linejoin: round" />
      <path d="M24,25.82c1.8.32,3,.84,3,1.43,0,1-3.13,1.75-7,1.75s-7-.78-7-1.75c0-.59,1.18-1.12,3-1.43"
        style="fill: none;stroke: #fff;stroke-linecap: round;stroke-linejoin: round" />
      <path d="M24,23.75c4.38.57,7.5,2,7.5,3.75,0,2.21-5.15,4-11.5,4s-11.5-1.79-11.5-4c0-1.72,3.12-3.19,7.5-3.75"
        style="fill: none;stroke: #fff;stroke-linecap: round;stroke-linejoin: round" />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'mapGeolocMarkerSVG',
  props: {
    bgColor: {
      type: String,
      default: '019DDF',
    },
    color: {
      type: String,
      default: '#FFF',
    },
  }
}
</script>